import domReady from '@wordpress/dom-ready';

domReady(async () => {
	const selectSelector = '.js-select';
	const selects = document.querySelectorAll(selectSelector);

	if (!selects.length) {
		return;
	}

	const { Select } = await import('./select');

	selects.forEach((selectElem) => {
		const options = {
			searchEnabled: false,
			shouldSort: false,
		};

		const select = new Select({
			options,
			selector: selectSelector,
			element: selectElem,
		});
		select.init();
	});
});
